import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { TopBar } from "@/components/TopBar";
import { Footer } from "@/components/Footer";
import { MetricsHud } from "@/components/admin/MetricsHud";
import { ActivityChart, LanguageChart } from "@/components/admin/Charts";
import { UsersTable } from "@/components/admin/UsersTable";
import { UserPanel } from "@/components/admin/UserPanel";
import { api, errMsg } from "@/lib/api";

export default function Admin() {
  const [metrics, setMetrics] = useState(null);
  const [users, setUsers] = useState([]);
  const [query, setQuery] = useState({ search: "", status: "all", sort: "created_desc" });
  const [selected, setSelected] = useState(null);

  const loadUsers = useCallback(() => api.get("/admin/users", { params: query }).then((r) => setUsers(r.data)).catch(() => {}), [query]);
  const loadMetrics = () => api.get("/admin/metrics").then((r) => setMetrics(r.data)).catch(() => {});

  useEffect(() => {
    loadMetrics();
    const t = setInterval(loadMetrics, 10000);
    return () => clearInterval(t);
  }, []);
  useEffect(() => {
    const d = setTimeout(loadUsers, 250);
    const t = setInterval(loadUsers, 10000);
    return () => { clearTimeout(d); clearInterval(t); };
  }, [loadUsers]);

  const toggle = async (u, disabled) => {
    try {
      await api.post(`/admin/users/${u.user_id}/status`, { disabled });
      setUsers((l) => l.map((x) => (x.user_id === u.user_id ? { ...x, disabled } : x)));
      toast.success(`${u.name} ${disabled ? "disabled" : "enabled"}`);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div className="min-h-screen">
      <TopBar mode="admin" />
      <main className="mx-auto max-w-[1440px] space-y-8 px-4 py-10 sm:px-8">
        <div className="fade-up flex flex-col justify-between gap-4 border-b border-border pb-8 md:flex-row md:items-end">
          <div>
            <div className="eyebrow">F.R.I.D.A.Y. // Super Admin</div>
            <h1 className="mt-3 font-display text-4xl font-extrabold tracking-tighter sm:text-5xl">Command <span className="aurora-text">Center</span></h1>
          </div>
          <div className="font-mono text-[11px] tracking-widest text-muted-foreground">
            DB {metrics?.db_latency_ms ?? "—"}ms · LIVE ROOMS {metrics?.live_rooms ?? "—"} · <span className="text-[color:var(--au-green)]">ALL SYSTEMS NOMINAL</span>
          </div>
        </div>
        <MetricsHud m={metrics} />
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="holo-panel p-5 lg:col-span-8"><div className="eyebrow mb-4">Global usage · minutes / day</div><ActivityChart data={metrics?.activity || []} /></div>
          <div className="holo-panel p-5 lg:col-span-4"><div className="eyebrow mb-4">Languages in use</div><LanguageChart data={metrics?.languages || []} /></div>
        </div>
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className={selected ? "lg:col-span-7" : "lg:col-span-12"}>
            <UsersTable users={users} query={query} setQuery={setQuery} selected={selected?.user_id} onSelect={setSelected} onToggle={toggle} />
          </div>
          {selected && <div className="lg:col-span-5"><UserPanel user={selected} onClose={() => setSelected(null)} /></div>}
        </div>
      </main>
      <Footer />
    </div>
  );
}
